import React, { useState } from 'react';
import { Button, ListGroup, ListGroupItem } from 'reactstrap';
import Fuse from 'fuse.js';
import { useAllEventAccountsQuery } from '../../graphql/queries/allEventAccounts.generated';
import ClassicLoadingSpinner from '../../components/LoadingSpinner/ClassicLoadingSpinner';
import { ContentSection } from '../../components/Layout/ContentSection';
import { useHistory } from 'react-router';
import i18n from '@/utils/i18n';
import { Routes } from '@/utils/routes';
import { SearchInput } from '../../components/SearchInput';
import { isDev, isLocalDev } from '@/utils/isDev';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

export const EventsAccountsIndexView = () => {
  useDocumentTitle('PageTitles:eventAccounts');
  const history = useHistory();
  const { loading, error, data } = useAllEventAccountsQuery({
    fetchPolicy: 'no-cache',
  });
  const [search, setSearch] = useState('');

  if (error)
    return (
      <div>
        {i18n.t('Common:error')}: {error.message}
      </div>
    );

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <ClassicLoadingSpinner />
      </div>
    );
  }

  const eventAccounts = data?.eventAccounts;
  let searchResult = eventAccounts;

  if (eventAccounts && search !== '') {
    const fuse = new Fuse(eventAccounts, {
      keys: ['name', 'id'],
      threshold: 0.3,
    });

    searchResult = fuse.search(search).map((result) => {
      return result.item;
    });
  }

  return (
    <ContentSection
      title={i18n.t('EventAccount:eventAccountsTitle')}
      collapsable={false}
    >
      {(isDev() || isLocalDev()) && (
        <div className="d-flex justify-content-end mb-4">
          <Button
            color="primary"
            onClick={() => {
              history.push(Routes.createEventAccount());
            }}
          >
            {i18n.t('EventAccount:createEventAccount')}
          </Button>
        </div>
      )}

      <SearchInput
        paramName="search"
        onChange={setSearch}
        placeholder={i18n.t('EventAccount:searchPlaceholder')}
      />

      <ListGroup className="mt-2">
        {searchResult?.map((eventAccount) => (
          <ListGroupItem
            action
            key={eventAccount.id}
            href={'/event-account/' + eventAccount.id}
            tag="a"
          >
            {eventAccount.name}

            <small className="text-muted d-block">{eventAccount.id}</small>
          </ListGroupItem>
        ))}
      </ListGroup>
    </ContentSection>
  );
};
